import { render, staticRenderFns } from "./GraficosCustom.vue?vue&type=template&id=0646d60e&"
import script from "./GraficosCustom.vue?vue&type=script&lang=js&"
export * from "./GraficosCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports